<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}" style="background-image: url('assets/images/{{bannerImage}}');">
          <h1 class="bani-title mb-0">{{activeLanguageTranslations?.correctionLabel}}</h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="static-content-heading-wrapper">{{activeLanguageTranslations?.correctionLabel}}</div>
        <div class="static-content-paragraph">
          {{activeLanguageTranslations?.paragraph1}}
        </div>
        <div class="static-content-paragraph">
          {{activeLanguageTranslations?.paragraph2}}
        </div>
        <div class="static-content-paragraph sggs-link">
          <a class="know-more" href="mailto:{{activeLanguageTranslations?.correctionEmail}} ">{{activeLanguageTranslations?.correctionEmail}} </a>
        </div>
       
      </div>
       <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
